import { SxProps, Theme } from '@mui/system';

const styles = {
  container: { mt: '-14px' },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    pb: 1,
    mt: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
